import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ticketing-controles',
  templateUrl: './controles.component.html',
  styleUrls: ['./controles.component.scss']
})
export class ControlesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
